import { get } from 'lodash'

/**
 *
 * @param response
 * @return {undefined|*}
 */
function redirect(response) {
  const redirectUrl = get(response, '__response.redirect')
  if (redirectUrl) {
    return redirectUrl
  } else {
    return undefined
  }
}

export default redirect
